import {
  MY_ACCOUNT,
  MY_LISTS,
} from "@/components/MyFavorites/v1/MyList/constant"

export const shareListModalDataLayerEvents = data => {
  const {
    name = "",
    actionType = "",
    pageType = "",
    eventStatus = "",
    eventType = "",
    sharedURL = "",
  } = data
  const { adobeDataLayer: { getState } = {} } = window
  const pageState = getState?.("page") || {}
  const page = pageState
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: `${MY_ACCOUNT}:${MY_LISTS}:${pageType}:${actionType}`,
    eventMsg: "n/a",
    eventName: `${MY_ACCOUNT}:${MY_LISTS}:${pageType}:${actionType}`,
    eventStatus: eventStatus || "n/a",
    eventType: `${eventType}`,
    internalLinkName: `${actionType}`,
    internalLinkPosition: `${MY_ACCOUNT}:${MY_LISTS}:${pageType}`,
    internalLinkType: `${MY_ACCOUNT}:${MY_LISTS}:${pageType}:${actionType}:${name}`,
    internalLinkURL: `${sharedURL}`,
    internalLinkZoneName: `${MY_ACCOUNT}:${MY_LISTS}:${pageType}:${name}`,
  }
  window.adobeDataLayer.push({
    event: "cmp:click",
    eventInfo,
    page,
  })
}
